export const BOOLEAN = 'dt:custom_field_type:boolean';
export const CURRENCY = 'dt:custom_field_type:currency';
export const DATE = 'dt:custom_field_type:date';
export const DATETIME = 'dt:custom_field_type:datetime';
export const DECIMAL = 'dt:custom_field_type:decimal';
export const INTEGER = 'dt:custom_field_type:integer';
export const LINK = 'dt:custom_field_type:link';
export const LIST = 'dt:custom_field_type:list';
export const RECORD = 'dt:custom_field_type:record';
export const STRING = 'dt:custom_field_type:string';